import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EIntegrationTypes } from '@feathr/blackbox';
import { UniversalSelect } from '@feathr/components';

interface IChannelOption {
  id: EIntegrationTypes;
  name: string;
}

interface IProps {
  onChange: (value?: EIntegrationTypes[]) => void;
  value?: EIntegrationTypes[];
}

function CampaignChannelSelect({ onChange, value }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  function handleSelectChannel(options: IChannelOption[]): void {
    onChange(options.map(({ id }) => id));
  }

  const options: IChannelOption[] = [
    { id: EIntegrationTypes.Tradedesk, name: t('Display Advertising') },
    { id: EIntegrationTypes.Facebook, name: t('Meta') },
  ];

  return (
    <UniversalSelect<IChannelOption>
      isMulti={true}
      label={t('Channels')}
      name={'campaign-channel-select'}
      onSelectMulti={handleSelectChannel}
      options={options}
      placeholder={t('All channels')}
      value={value ? options.filter(({ id }) => value.includes(id)) : []}
    />
  );
}

export default CampaignChannelSelect;
